







































































































import { Component } from 'vue-property-decorator';
import MixinAuth from '@/plugins/podolib/services/helper/mixins/auth';
import AccountTermsAndConditions from '@/components/account/AccountTermsAndConditions.vue';

@Component({
  components: {
    AccountTermsAndConditions,
  },
})
export default class LayoutAuthTrial extends MixinAuth {
  async signOut() {
    const _email = this.$pdc.cognito!.user.username;
    // Sign out ...
    await this.$pdc.cognito!.signOut();
    // Analytics
    this.$pdc.analytics?.actions.trackSuccess('User SignedOut', {
      email: _email,
    });
    this.$pdc.analytics?.actions.reset();
    // Redirect...
    await this.$router.push({ name: 'auth-sign-in', query: { ...this.campaignQueryParams } });
  }

  async goToSignUp() {
    // Analytics
    this.$pdc.analytics?.actions.trackSuccess('User SignupClicked', {
      ...this.campaignQueryParamsToEvent,
    });
    // Redirect...
    await this.$router.push({ name: 'auth-sign-up', query: { ...this.campaignQueryParams } });
  }

  async goToSignIn() {
    // Analytics
    this.$pdc.analytics?.actions.trackSuccess('User SigninClicked', {
      ...this.campaignQueryParamsToEvent,
    });
    // Redirect...
    await this.$router.push({ name: 'auth-sign-in', query: { ...this.campaignQueryParams } });
  }
}
